import React, {useEffect} from 'react';

type SnippetAdditionalTermsProps = {
	html: string
	snippetCode: string
}

/** Renders CMS HTML like {@link SnippetFooter} so anchor tags and markup work. */
export function SnippetAdditionalTerms(props: SnippetAdditionalTermsProps) {
	const elementId = `bl-snippet-additional-terms-${props.snippetCode}`;

	useEffect(() => {
		const el = document.getElementById(elementId);
		if (el && props.html !== null)
			el.innerHTML = props.html;
	}, [props.html, elementId]);

	return (
		<p id={elementId} className='bLoyal-signup-additional-terms bLoyal-center'></p>
	);
}
